<template>
  <div class="flex items-center gap-2">
    <RadioButton
      v-model="model"
      :inputId="`${name}${value}`"
      :name="name"
      :value="value"
      class="w-6 h-6"
      :size="size"
    />
    <label :class="labelClass" class="dark:text-white" :for="`${name}${value}`">
      {{ label }}
    </label>
  </div>
</template>

<script setup>
const model = defineModel();
const props = defineProps({
  label: {
    type: String,
    default: "Cheese",
  },
  name: {
    type: String,
  },
  value: {
    type: String,
  },
  size: {
    type: String,
  },
  labelClass: {
    type: String,
    default: "",
  },
});
</script>
